module.exports = __webpack_public_path__ + "media/assets/images/blog/IMG_IMPACT2030-small-af4e00ba5ea533bd33a22bbe07c5ddcb.png";